<template>
  <a-card :bordered="false">
    <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
      <div></div>
      <a-button type="primary" @click="addArticle">
        {{ $t('ADD') || '添加' }}
      </a-button>
    </div>
    <div>
      <a-row :gutter="16">
        <a-col
          :span="4"
          v-for="item in table.data"
          :key="item.id">
          <a-card
            style="margin-bottom: 20px"
            hoverable>
            <img
              slot="cover"
              alt="example"
              class="cover-img"
              :src="item.coverPath"
            />
            <template slot="actions" class="ant-card-actions">
              <a-icon type="edit" @click="editArticle(item.id)">
              </a-icon>
              <a-icon type="close" @click="deleteArticle(item.id)">
              </a-icon>
            </template>
            <a-card-meta :title="item.title" :description="item.subTitle">
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      :footer="null"
             title="文章编辑"
             v-model="form.visible">
      <article-edit
        v-if="form.visible"
        :index-poster-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </article-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryArticles,
  _deleteArticle,
  _upArticle,
  _downArticle,
} from '@/api/articleApi';
import ArticleEdit from './ArticleEdit.vue';

async function getArticleList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryArticles({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addArticle() {
  this.$router.push('/articles/add');
}

function editArticle(articleId) {
  this.form.data.id = articleId;
  this.form.visible = true;
  this.$router.push(`/articles/${articleId}`);
}

function editArticleJump(articleId) {
  this.jumpForm.data.id = articleId;
  this.jumpForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.jumpForm.data.id = null;
  this.jumpForm.visible = false;
  this.getArticleList();
}

async function deleteArticle(articleId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteArticle(articleId);
      this.$message.success('删除成功');
      this.getArticleList();
    },
  });
}

async function upArticle(articleId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upArticle(articleId);
      this.$message.success('删除成功');
      this.getArticleList();
    },
  });
}

async function downArticle(articleId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downArticle(articleId);
      this.$message.success('删除成功');
      this.getArticleList();
    },
  });
}

export default {
  name: 'ArticleList',
  components: {
    ArticleEdit,
  },
  data() {
    return {
      jumpForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getArticleList,
    deleteArticle,
    editArticle,
    editArticleJump,
    addArticle,
    closeForm,
    upArticle,
    downArticle,
  },
  created() {
    this.getArticleList();
  },
};
</script>

<style scoped>
.cover-img {
  border-radius: 2px 2px 0 0;
  height: 300px;
  object-fit: cover;
  object-position: top;
}
</style>
